// extracted by mini-css-extract-plugin
export var parcelRow = "_qq-0";